import $ from 'jQuery';

/**
 * Initializes the sidebar navigation toggle in mobile viewport.
 * On click of .section-navigation, toggles aria-expanded and performs slideToggle
 * on the immediate .section-navigation--toggable.
 *
 * @returns {void}
 */
export default function () {
	$(document).on('click', '.page-sidebar-navigation__group .section-navigation', function () {
		const $btn = $(this);
		const $list = $btn.next('.section-navigation--toggable');

		if (!$list.length) return;

		const isExpanded = $btn.attr('aria-expanded') === 'true';
		$btn.attr('aria-expanded', !isExpanded);
		$list.slideToggle(300);
	});
}
